import {isNotNil} from 'ramda';

import {Nullish} from 'shared/web';

import {getLevelFraction} from './getLevelFraction';

/** Bounds assumed when a call site stores the level as a whole percentage. */
export const DEFAULT_LEVEL_MIN = 0;
export const DEFAULT_LEVEL_MAX = 100;

/** Step assumed when a call site does not define one; the gauges count in whole percent. */
export const DEFAULT_STEP = 1;

export const PERCENT_SCALE = 100;

export function resolveLevel(
  value: number | Nullish,
  min: number = DEFAULT_LEVEL_MIN,
  max: number = DEFAULT_LEVEL_MAX
) {
  const fraction = getLevelFraction(value, min, max);

  return {
    min,
    max,
    fraction,
    percent: Math.round((fraction ?? 0) * PERCENT_SCALE),
    isRecorded: isNotNil(fraction),
  };
}
